import * as React from 'react';
import { FormContext, TimeSpan } from "../context/Form";
import DatePicker from "react-datepicker";

type DateRangeProps = {
    timespan: TimeSpan;
    index: number;
    canDelete: boolean;
}

export const DateRange = (props: DateRangeProps): JSX.Element => {
    const [data, dispatch] = React.useContext(FormContext);
    const [startDate, setStartDate] = React.useState<any>(new Date(0).setUTCSeconds(props.timespan.start_date));
    const [endDate, setEndDate] = React.useState<any>(new Date(0).setUTCSeconds(props.timespan.end_date));

    const updateStartDate = (date: any) => {
        const newData = {...data};
        setStartDate(date);
        newData.time_span[props.index].start_date = Math.round(date.getTime() / 1000);
        dispatch(
            {
                type: 'STORE',
                payload: {
                    data: newData
                },
            }
        );
    }

    const updateEndDate = (date: any) => {
        const newData = {...data};
        setEndDate(date);
        newData.time_span[props.index].end_date = Math.round(date.getTime() / 1000);
        dispatch(
            {
                type: 'STORE',
                payload: {
                    data: newData
                },
            }
        );
    }

    const removeTimeSpan = () => {
        const newData = {...data};
        newData.time_span.splice(props.index,1);
        dispatch(
            {
                type: 'STORE',
                payload: {
                    data:newData
                },
            }
        );
    }

    return <div className={'c-dateranges__daterange'}>
        <label>Periode {props.index + 1}</label>
        <DatePicker
            selected={startDate}
            onChange={date => updateStartDate(date)}
            selectsStart
            startDate={startDate}
            endDate={endDate}
        />
        <DatePicker
            selected={endDate}
            onChange={date => updateEndDate(date)}
            selectsEnd
            startDate={startDate}
            endDate={endDate}
            minDate={startDate}
        />
        { props.canDelete && <button className={'c-segments__remove-timespan'} onClick={removeTimeSpan}>Verwijderen</button> }
    </div>;
}
